/**
 * Admin on/off switches from the Settings page, delivered in app data. A
 * switch is off only when its value is "off"; a missing switch counts as on,
 * matching the backend's Setting::isSwitchedOff.
 */
export const OPAY_CHECKOUT_SETTING = "opay_checkout";

type SettingLike = { setting?: string; value?: string | null };

export const isSwitchedOff = (settings: unknown, name: string): boolean =>
  Array.isArray(settings) &&
  settings.some(
    (s: SettingLike) =>
      s?.setting === name &&
      String(s?.value ?? "")
        .trim()
        .toLowerCase() === "off",
  );
